import { List } from 'immutable';
import { MenuItemCategories } from 'records/MenuItemCategory';
import BaseList from 'records/BaseList';

import {
  MENU_ITEM_CATEGORIES_ASYNC_ACTION_START,
  MENU_ITEM_CATEGORIES_ASYNC_ACTION_ERROR,
  MENU_ITEM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
  MENU_ITEM_CATEGORIES_RESET_STATE,
} from 'actions/menuItemCategories';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENU_ITEM_CATEGORIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_CATEGORIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_CATEGORIES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const menuItemCategoriesData = MenuItemCategories(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: menuItemCategoriesData,
    });
  },
  [MENU_ITEM_CATEGORIES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuitemCategories(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
